import React from 'react';
import { csvColumnHeaders } from '../../config/histogramDictionary';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ReportPDF from './ReportPDF';

const ReportControls = ({
  charts,
  histogramResults,
  precalculatedCSVData,
  precalculatedShape,
  snapshot,
  totalArea,
  yearsSelected
}) => {
  const downloadAsCSV = () => {
    const edge = window.navigator.msSaveOrOpenBlob ? true : false;
    let csvContent;
    if (precalculatedCSVData) {
      csvContent = edge ? precalculatedCSVData.slice(28) : precalculatedCSVData;
    } else {
      csvContent = edge ? '' : 'data:text/csv;charset=utf-8,';
      csvContent += `${csvColumnHeaders.join(',')} \n`;

      csvContent += `Total Area, NA, NA, ${totalArea} \n`;

      histogramResults.forEach(rowOfData => {
        const dataCategory = rowOfData.dataCategory;
        const dataSubcategory = rowOfData.dataSubcategory;
        const dataYear = rowOfData.dataYear;
        const acreCount = Math.round(rowOfData.acreCount);

        csvContent += `${dataCategory}, ${dataSubcategory}, ${dataYear}, ${acreCount} \n`;
      });
    }

    const encodedUri = encodeURI(csvContent);
    const csvFileName = 'Plowprint Data.csv';

    // Download on Edge - we currently have no functionality for exporting in IE.
    if (window.navigator.msSaveOrOpenBlob) {
      csvContent.slice(27); // We don't need the text/csv;charset=utf-8 since it's passed directly to the blob
      const csvBlob = new Blob([csvContent], {
        type: 'text/csv;charset=utf-8;'
      });
      window.navigator.msSaveOrOpenBlob(csvBlob, csvFileName);
    } else {
      // In order to give the downloaded file a custom name, we must create a hidden <a> DOM node and set its download attribute manually.
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', csvFileName);
      document.body.appendChild(link); // Required for Firefox
      link.click();
      document.body.removeChild(link);
    }
  };

  const subtitleText = precalculatedShape
    ? precalculatedShape
    : 'Custom Shape for the years';

  return (
    <div className="report-buttons-container">
      {totalArea && (
        <PDFDownloadLink
          className="report-button button pointer"
          document={
            <ReportPDF
              subtitleText={subtitleText}
              charts={charts}
              totalArea={totalArea}
              snapshot={snapshot}
              yearsSelected={yearsSelected}
            />
          }
          fileName="Plowprint Report.pdf"
        >
          Download PDF
        </PDFDownloadLink>
      )}
      {/* </div> */}
      <div
        className="report-button csv button pointer"
        onClick={() => downloadAsCSV()}
      >
        Download CSV
      </div>
    </div>
  );
};

export default ReportControls;
